import $ from 'jquery';
import _ from 'underscore';
import _datepicker from 'jquery-ui/ui/widgets/datepicker';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import nv from 'nvd3';
import Moment from 'moment';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import template from '@/../templates/dashboard/widgets/bandwidth.hbs';
import {select, selectAll} from 'd3';

var chart_heights = { 4 : 180, 6 : 250, 12: 300 };

var BandwidthWidget = Marionette.View.extend(LayoutMixin).extend({
    modelEvents: {
        'change': 'render_chart'
    },
    className: function(){ return "widget bandwidth " + this.getWidth(); },
    template: Handlebars.compile(template),
    ui: {
        target : '.panel-body svg',
        spinner: '.panel-body .spinner',
        show_messages: '.show-messages',
        show_bytes : '.show-bytes',
        title : '.panel-heading .title',
        start_date: '.panel-heading .start-date',
        end_date: '.panel-heading .end-date',
        dropdown: '.dropdown-toggle',
        dropdown_title: '.dropdown .title',
        interval: 'input:radio[name=\'interval\']',
        refresh: '.refresh'
    },
    interval: 'days',
    events: {
        'click @ui.show_messages': 'show_messages',
        'click @ui.show_bytes': 'show_bytes',
        'change @ui.end_date': 'date_submit',
        'click @ui.interval' : 'update_interval',
        'click @ui.refresh' : 'date_submit'
    },
    templateContext: function() {
        var strings = {
            title : this.options.title || 'Device/Agent Bandwidth',
        };
        var start_date = new Moment.utc(this.options.date);
        if ( this.model.type === 'devicegroup_bandwidth' ){
            start_date.subtract(180, 'days');
        } else if (this.model.type === 'device_bandwidth') {
            start_date.subtract(7, 'days');
        }
        var end_date = new Moment.utc(this.options.date);
        return {
            s : strings,
            width: this.getWidth(),
            start_date: start_date.format('MMM DD, Y'),
            end_date: end_date.format('MMM DD, Y'),
        };
    },
    onAttach: function() {
        this.ui.dropdown.dropdown();
        $(this.ui.start_date).hide();
        $(this.ui.target).hide();
        var date = this.options.date;
        if ( date === undefined ) {
            var d = new Date();
            date = new Date( Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 11, 59, 59 ) );
        }
        if ( this.model.type === 'devicegroup_bandwidth' ){
            var min_days = date.getUTCDate() - 1;
            $(this.ui.end_date).datepicker({
                dateFormat: 'MM dd, yy',
                minDate: '-6m -' + min_days + 'd',
                maxDate: '0d'
            });
        } else if (this.model.type === 'device_bandwidth') {
            date.setUTCHours(23);
            date.setUTCMinutes(59);
            date.setUTCSeconds(59);
            $(this.ui.end_date).datepicker({
                dateFormat: 'MM dd, yy',
                minDate: '-7d',
                maxDate: '0d'
            });
        }
        this.render_chart(this.model);
    },
    // render a chart, with a data_types
    // model: placeholder var for render requests from events
    // ex: ['dmo','dmi']
    render_chart: function(model, data_types, title, ylabel, colors){
        // clean out stray tooltips
        var t = $('.nvtooltip.xy-tooltip');
        t.remove();
        if (!this.ui.end_date.datepicker) return;
        $(this.ui.target).show();
        $(this.ui.spinner).hide();

        if (!data_types && this.options.data_types) data_types = this.options.data_types;

        if (!_.isArray(data_types) && this.options.data_types ){
            data_types = this.options.data_types;
        }

        if (!ylabel ) ylabel = this.options.ylabel || '';
        if (!Array.isArray(colors)) colors = this.options.colors || ['black', 'yellow'];
        var chart_height = chart_heights[this.options.columns];
        var target = $(this.ui.target)[0];
        var self = this;
        
        nv.addGraph(function() {
            var chart = nv.models.lineChart()
                .height(chart_height) // set the height of the chart
                .focusEnable( true )
                .margin({top: 10, right: 60, bottom: 10, left: 100 });
            chart.color(colors);
            chart.yAxis
                .axisLabel(ylabel)
                .axisLabelDistance(30)
                .showMaxMin(true)
                .tickPadding(10);
            chart.xAxis
                .tickFormat(function(d) {
                    var md = new Moment(d);
                    switch (self.interval) {
                        case 'minutes':
                            if (md.utc().hours() < 1 && md.utc().minutes() === 0 ) {
                                return md.utc().format("MMM DD YYYY");
                            } else {
                                return md.utc().format("HH:mm");
                            }
                        case 'hours':
                            if (md.utc().hours() < 1 ) {
                                return md.utc().format("MMM DD YYYY");
                            } else {
                                return md.utc().format("DD HH:mm");
                            }
                        default:
                            return md.utc().format("MMM DD YYYY");
                    }
                })
                .tickPadding(10);

            chart.x2Axis
                .tickFormat(function(d) {
                var md = new Moment(d);
                    switch (self.interval) {
                        case 'minutes':
                            if (md.utc().hours() < 1 && md.utc().minutes() === 0 ) {
                                return md.utc().format("MMM DD YYYY");
                            } else {
                                return md.utc().format("HH:mm");
                            }
                        case 'hours':
                            if (md.utc().hours() < 1 ) {
                                return md.utc().format("MMM DD YYYY");
                            } else {
                                return md.utc().format("DD HH:mm");
                            }
                        default:
                            return md.utc().format("MMM DD YYYY");
                    }
                })
                .tickPadding(10);

            chart.useInteractiveGuideline(true);
            chart.legendPosition('top');
            var dates = {
                end_date: self.ui.end_date.datepicker('getDate')
            };
            select(target)
                .datum( self.model.d3_datum(data_types, dates) )
                .transition().duration(500)
                .call(chart);
            nv.utils.windowResize(chart.update);
            return chart;
        });
    },
    show_messages: function() {
        var type = ['dmi', 'dmo'];
        this.options.data_types = type;
        this.options.colors =  ['#ffcd00', '#54585a'];
        this.ui.dropdown_title.text('Messages');
        this.render_chart(this.model, this.options.data_types, 'Device/Agent Bandwidth (messages)', 'Messages');
    },
    show_bytes: function() {
        var type = ['dbo', 'dbi'];
        this.ui.dropdown_title.text('Bytes');
        this.render_chart(this.model, type, 'Device/Agent Bandwidth (bytes)', 'Bytes', ['#21ABD4', '#FF9F4A']);
    },
    show_date: function() {
        if (this.ui.end_date.val() === undefined || this.ui.start_date.val() === undefined) {
            return;
        }
        var self = this;
        var start_date = this.ui.start_date.datepicker('getDate');
        var end_date = this.ui.end_date.datepicker('getDate');
        self.model.fetch_day(start_date, end_date, self.interval).then(self.render_chart());
    },
    date_submit: function() {
        var self = this;
        $(this.ui.target).hide();
        $(this.ui.spinner).show();
        setTimeout(function(){ self.show_date(); }, 500);
    },
    update_interval: function(e){
        this.interval = e.target.value;
        this.show_date();
    },
    onBeforeDestroy: function(){
        selectAll(this.ui.target).remove();
        var t = $('.nvtooltip.xy-tooltip');
        t.remove();
    }
});

export default BandwidthWidget;

